import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../store"

export const getLocalToken = (): string | undefined => {
  const data = localStorage.getItem("token")
  return data && data !== "" && data !== null ? data : undefined
}

const initialState = {
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  token: localStorage.getItem("token")
}

export const authSlice = createSlice({
  name: "authentication",
  initialState: initialState,
  reducers: {
    loginState(state: any, { payload }: PayloadAction<any>) {
      const initialData = { ...payload }

      if (initialData?.token) {
        localStorage.setItem("token", initialData?.token)
        state.token = initialData?.token
      }
      if (initialData?.user) {
        state.user = initialData?.user
        localStorage.setItem("user", JSON.stringify(initialData?.user))
      }
    },
    logoutState: (state: any) => {
      state.user = {}
      state.token = null
      state.permissions = {}
      state.tenant = {}
      state.config = {}
      state.allowedLocations = [{}]
      state.currentWhLoc = null
      localStorage.removeItem("token")
      localStorage.removeItem("user")
    }
  }
})

export const authReducer = authSlice.reducer

export const { loginState, logoutState } = authSlice.actions

export const getUserState = (state: RootState) => state.authentication.user
